<nz-table class="full-width" #resumeTable [nzData]="resumeList" [nzPaginationType]="'small'" [nzPageSize]="8">
  <thead>
    <tr>
      <th [nzWidth]="'250px'">Name</th>
      <th>Source</th>
      <th>Company</th>
      <th>Position</th>
      <th>Voice</th>
      <th>Personality</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (resume of resumeTable.data; track resume.id; let i = $index) {
      <tr>
        <td>
          <img class="portrait" [src]="resume.subData.content?.portraitImageUrl" />
          {{ resume.subData.content?.firstName }} {{ resume.subData.content?.lastName }}
        </td>
        <td>
          {{ getResumeSourceName(resume) }}
        </td>
        <td>
          {{ resume.subData.content?.mostRecentCompany }}
        </td>
        <td>
          {{ resume.subData.content?.mostRecentPosition }}
        </td>
        <td>{{ getDeepgramVoiceById(resume)?.accent }} {{ getDeepgramVoiceById(resume)?.gender }}</td>
        <td>
          @for (personality of selectedPersonalityList(resume)(); track $index) {
            <nz-tag [nzBordered]="false" [nzColor]="personality?.unsafeSubData?.color">{{ personality?.title }}</nz-tag>
          }
        </td>
        <td>
          <div class="vertical">
            <button nz-button nzType="default" nzSize="small" [nzDanger]="false" (click)="onViewDetailsClick(resume)">
              <span nz-icon style="font-size: 18px" class="material-symbols-rounded">pageview</span>
              View Summary
            </button>

            <button nz-button nzType="default" nzSize="small" [nzDanger]="false" (click)="onEditProfileClick(resume)">
              <span nz-icon style="font-size: 18px" class="material-symbols-rounded">edit</span>
              Edit
            </button>

            <button nz-button nzType="default" nzSize="small" [nzDanger]="false" (click)="onCopyProfileClick(resume)">
              <span nz-icon style="font-size: 18px" class="material-symbols-rounded">content_copy</span>
              Duplicate
            </button>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-view-resume-details
  [resume]="showDetailsResume!"
  [(isVisible)]="isViewResumeDetailsVisible"
  (isVisibleChange)="onViewResumeDetailsVisibleChange($event)"
></app-view-resume-details>

<app-edit-resume [resume]="showDetailsResume!" [(isVisible)]="isEditResumeVisible" [isEdit]="true"></app-edit-resume>
